// ABOUTME: Topbar dashboard switcher for the warehouse home page — a DropdownBase listing the saved BI dashboards
// ABOUTME: plus a built-in "Standaard" option, with a star to set the selected dashboard as this user's home default.
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import { tokens } from "../../../../theme";
import Text from "../../../../components/theme/text/Text";
import { DropdownBase } from "../../../../components/theme/dropdowns/Dropdown";
import { useGetBiDashboardsQuery, useSetBiDashboardPrimaryMutation } from "../../../../newapi/global/businessIntelligence";
import Subheading from "../../../../components/theme/text/Subheading";

// The built-in (hardcoded) home dashboard — selecting this renders the original charts instead of a BI dashboard.
const DEFAULT_KEY = "__default__";

export const DashboardSwitcher = ({ selectedId, onSelect }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { data } = useGetBiDashboardsQuery();
    const dashboards = data?.data ?? [];
    const [setPrimary, { isLoading: settingPrimary }] = useSetBiDashboardPrimaryMutation();

    const options = useMemo(
        () => [{ id: DEFAULT_KEY, name: t("dashboard") }, ...dashboards.map((d) => ({ id: d.id, name: d.name }))],
        [dashboards, t]
    );

    const selectedKey = selectedId ?? DEFAULT_KEY;
    const selectedDashboard = dashboards.find((d) => d.id === selectedId) ?? null;
    const current = options.find((o) => o.id === selectedKey);

    // DropdownBase passes the selected option's valueKey value (or null on deselect); map "__default__" → built-in.
    const handleChange = (value) => onSelect(value == null || value === DEFAULT_KEY ? null : value);

    const handleTogglePrimary = () => {
        if (!selectedDashboard || settingPrimary) return;
        setPrimary({ id: selectedDashboard.id, primary: !selectedDashboard.isPrimary });
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, "@media screen and (max-width: 47.9375em)": { display: "none" } }}>
            <DropdownBase
                displayName="name"
                valueKey="id"
                options={options}
                selected={selectedKey}
                onChange={handleChange}
                closeOnSelection
                disallowDeselection
            >
                <ButtonBase
                    sx={{
                        height: 32,
                        // px: 2,
                        gap: 1,
                        borderRadius: 4,
                        // background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                        // border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                        // boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                        color: colors.txt["secondary"],
                    }}
                >
                    {/* <DashboardOutlinedIcon fontSize="small" sx={{ color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] }} /> */}
                    <Subheading semibold sx={{ whiteSpace: "nowrap" }}>{current?.name}</Subheading>
                    
                    <KeyboardArrowDownOutlinedIcon fontSize="small" />
                </ButtonBase>
            </DropdownBase>

            {selectedDashboard &&
                <ButtonBase
                    onClick={handleTogglePrimary}
                    disabled={settingPrimary}
                    title={t(selectedDashboard.isPrimary ? "primary" : "make_primary")}
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 4,
                        // color: selectedDashboard?.isPrimary ? colors.purple[400] : colors.txt['primary']
                        background: selectedDashboard.isPrimary ? colors.purple[400] : colors.purple[100],
                        color: selectedDashboard.isPrimary ? (theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"]) : colors.purple[400],
                    }}
                >
                    {selectedDashboard.isPrimary ? <StarOutlinedIcon fontSize="small" /> : <StarBorderOutlinedIcon fontSize="small" />}
                </ButtonBase>
            }
        </Box>
    );
};
